import { format } from "date-fns";

export const transformFileData = (arr) => {
  const header = arr[0];
  const result = [];
  for (let i = 1; i < arr.length; i++) {
    const o = { id: i };
    header.forEach((el, hi) => {
      o[el] = arr[i][hi];
    });
    result.push(o);
  }
  return result;
};

export const formatISODate = (date) => format(new Date(date), "yyyy-MM-dd");

// Make Data Grid columns responsive: they share the table width equally, but never shrink
// below their configured width (the grid scrolls horizontally when they don't fit)
export const makeColumnsResponsive = (columns) =>
  columns.map((column) => ({ ...column, flex: 1, minWidth: column.width }));
